import { actions as reservationFormActions } from '@store/ducks/reservation-form-slice';
import { useField, validateYupSchema } from 'formik';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ReservationFormValues, ReservationModes } from 'types/reservation-form';

function isUUID(str: string) {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(str);
}

function choosePatient(values: ReservationFormValues) {
  // we have NON hilbi patient
  if (values.selectedPatient && !isUUID(values.selectedPatient.value)) {
    return {
      title: values.selectedPatient.value,
      selectedPatient: { ...values.selectedPatient, value: null as any },
    };
  }

  return { selectedPatient: values.selectedPatient };
}

export function useReservationFormMethods(mode: ReservationModes) {
  const dispatch = useDispatch();
  return {
    onMount: () => {
      switch (mode) {
        case 'add':
          dispatch(reservationFormActions.setupReservationAddForm());
          break;
        case 'create':
          dispatch(reservationFormActions.setupCreateReservationForm());
          break;
        case 'edit':
          dispatch(reservationFormActions.setupReservationEditForm());
          break;
      }
    },
    onUnMount: () => {
      dispatch(reservationFormActions.reset());
    },
    handleSubmit: (values: ReservationFormValues) => {
      const submitData = { ...values, ...choosePatient(values) };
      console.log(submitData);

      switch (mode) {
        case 'add':
          dispatch(reservationFormActions.submitReservationAddForm(submitData));
          break;
        case 'create':
          dispatch(reservationFormActions.submitReservationCreateForm(submitData));
          break;
        case 'edit':
          dispatch(reservationFormActions.submitReservationFormUpdate(submitData));
          break;
      }
    },
  };
}

export function useFormErrorRecovery(resetError: () => void, values: any, errorMessage?: string) {
  const [erroredValues, setErroredValues] = useState<any>(null);
  useEffect(() => {
    if (errorMessage && !erroredValues) {
      setErroredValues(values);
    }
  }, [errorMessage, values, erroredValues]);

  useEffect(() => {
    if (errorMessage) {
      if (erroredValues && erroredValues !== values) {
        resetError();
      }
    } else if (erroredValues) {
      setErroredValues(null);
    }
  }, [errorMessage, values, erroredValues]);
}

export function useFieldData(name: string) {
  const [_, meta, helpers] = useField(name);
  const { value, error, touched } = meta;
  const { setValue } = helpers;
  return { setValue, value, error, touched };
}
